import { Box, Switch, Typography } from '@material-ui/core';
import { PersonAddDisabled } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useCampfireQuery } from '../../../../../global/network/useCampfireQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { GET_CONFIG_ITEM } from '../admin-console-activity-reporting/config-item.gql';
import { GetConfigItem } from '../admin-console-activity-reporting/__generated__/GetConfigItem';

const CONFIG_KEY = 'applications-closed';

export const PublicSignUpsForm = () => {
  const { setSnackbar } = useSnackbar();
  const [closed, setClosed] = React.useState(false);
  const apiUrl = useApiUrl();
  const campfireMutation = useCampfireFetch({ defer: true });

  const { data, refetch } = useCampfireQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM, {
    options: { variables: { key: CONFIG_KEY } },
  });

  useEffect(() => {
    if (!data) return;
    setClosed(data.vm.configItem?.configItemValue?.flagValue ?? data.vm.configItem?.defaultValue ?? false);
  }, [data]);

  const onChange = () => {
    campfireMutation
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: CONFIG_KEY,
          value: !closed,
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Request failed');
        }
        setClosed(!closed);
        setSnackbar({
          variant: 'success',
          open: true,
          message: 'Settings updated',
        });
        refetch();
      })
      .catch(() => {
        setSnackbar({
          variant: 'error',
          open: true,
          message: 'Unable to update setting',
        });
      });
  };

  return (
    <Box>
      <Typography style={{ fontWeight: 600, fontSize: '16px', display: 'flex', alignItems: 'center' }}>
        <PersonAddDisabled style={{ fontSize: '14px', paddingRight: '5px' }} /> Public Sign Ups
      </Typography>
      <Typography variant={'body2'} style={{ fontSize: '14px', color: '#808080' }}>
        {'Control whether new volunteers can create an account'}
      </Typography>
      <Box display='flex' flex='1 1 auto' marginTop='1.5rem'>
        <Box style={{ paddingTop: 4, paddingRight: 8 }}>
          <Switch
            name='applications-closed-toggle'
            color='primary'
            checked={closed}
            disabled={campfireMutation.isLoading}
            onChange={onChange}
            inputProps={{ 'aria-label': 'close public sign ups toggle' }}
          />
        </Box>
        <Box>
          <Box ml={1}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                color: '#333',
              }}
            >
              Close Public Sign Ups
            </Typography>
            <Typography style={{ fontSize: '12px', color: '#808080' }}>
              New volunteers cannot sign up from the public application page. <br />
              Invited volunteers and funnel links can still sign up.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
